module.exports = __webpack_public_path__ + "img/chateau-de-gaillon.66560f41.jpg";